import {
  Component,
  ViewEncapsulation,
  OnInit,
  EventEmitter,
  Input,
  OnDestroy
} from '@angular/core';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import _, { isArray, keyBy } from 'lodash';

import {
  Language,
  DepartureBoardService,
  UserService,
  EnterpriseSearchService,
  ServiceType,
  EnterpriseBasketService,
  HelperRoutines,
  WithSubscriptionComponent,
  Office,
  CarHireVehicleAvailibility,
  LogonService,
  ModalOpenerService,
  CarHireDetailFareRule,
  RailSearchJourneyType,
  RailFareProcessingService,
  RailJourneyFare,
  ParkingQuote,
  LoungeQuote,
  FastTrackQuote,
  BasketItem
} from '@sabstravtech/obtservices/angular';
import {
  BookableBasket,
  LogoutEnum,
  OBTRailJourneyFare,
  OBTRailJourneyOption,
  RailFareTypes,
  RailDirection,
  ServiceProvider
} from '@sabstravtech/obtservices/base';
import moment from 'moment';
declare var hex_hmac_md5: any;
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { LightningModalTypes } from '../core/classes/modal-types.enum';
import { ThemeService } from '../core/services/theme.service';

@Component({
  templateUrl: './modal.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .dark-modal .modal-content {
        background-color: #292b2c;
        color: white;
      }
      .dark-modal .close {
        color: white;
      }
    `
  ],
  standalone: false
})
export class ModalComponent {
  closeResult: string;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) {}
}
LightningModalTypes.ModalComponent.component = ModalComponent;
@Component({
  templateUrl: './modal-user-error.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ModalUserErrorComponent {
  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) {}

  public authError = 'Authorisation Error';
}
LightningModalTypes.ModalUserErrorComponent.component = ModalUserErrorComponent;

@Component({
  templateUrl: './modal-error.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ModalErrorComponent implements OnInit {
  constructor(
    public activeModal: NgbActiveModal,
    protected themeService: ThemeService
  ) {}
  public error = 'Unknown Error';
  public miError = false;
  public email = '';
  public number = '';
  public isScion = false;

  ngOnInit() {
    if (this.themeService.isScionEnv) {
      this.isScion = true;
    }
  }
}

LightningModalTypes.ModalErrorComponent.component = ModalErrorComponent;

@Component({
  templateUrl: './modal-success.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ModalSuccessComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {}
  public success = 'Success';

  ngOnInit() {}
}

LightningModalTypes.ModalSuccessComponent.component = ModalSuccessComponent;

@Component({
  templateUrl: './modal-network-error.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ModalNetworkErrorComponent implements OnInit {
  public error = null;
  public errorMessage = 'Unknown Error';
  public duplicateBooking = false;
  public paymentCardError = false;
  public liveRailError = false;
  public hotelCancelError = false;
  public unConfirmedBookingError = false;
  public titleNotSupportedError = false;
  public pureErrorMessageFromBE = false;
  public miErrorMessage = false;
  public errorLevel = 'Error';
  supportNumber = '0121 2345555';
  supportEmail = 'support@travelctm.com';
  bookableBasket: BookableBasket = null;
  isUISupportEmail = false;
  isUISupportPhone = false;
  isPriceChange = false;

  constructor(
    public activeModal: NgbActiveModal,
    public userService: UserService,
    public searchService: EnterpriseSearchService,
    private readonly router: Router,
    public basketService: EnterpriseBasketService,
    public helpers: HelperRoutines
  ) {
    this.bookableBasket = new BookableBasket(basketService, helpers);
  }

  ngOnInit() {
    console.log(this.error);
    if (typeof this.error === 'object') {
      if (this.error.message === 'This item already exists in this basket') {
        this.duplicateBooking = true;
        this.errorMessage = this.error.message;
      } else if (this.error.message === "Cannot read property 'trainServices' of undefined") {
        this.liveRailError = true;
        this.errorMessage =
          'The journey you have selected is not a direct route, please check the stations and try again';
      } else if (this.error?.message.includes('Payment failed for basket item ID')) {
        this.paymentCardError = true;
      } else if (
        this.error?.message.includes(
          'Hotel Get Booking Error: Cancellation was not successful, please try again or contact a support agent'
        )
      ) {
        this.hotelCancelError = true;
      } else if (this.error?.message.includes('Booking Unconfirmed')) {
        this.unConfirmedBookingError = true;
      } else if (this.error?.message.includes('Title not supported')) {
        this.titleNotSupportedError = true;
      } else if (this.error?.message.includes('The value entered for')) {
        this.miErrorMessage = true;
        this.errorMessage = this.error.message;
      } else if (this.error?.extensions?.code === 'FRIENDLY_ERROR') {
        this.pureErrorMessageFromBE = true;
        this.errorMessage = this.error.message;
        this.errorLevel = this.error?.extensions?.errorLevel;
      } else if (this.error.message.includes('One or more of the items within your basket has')) {
        this.isPriceChange = true;
        this.errorMessage = this.error.message;
      } else {
        this.errorMessage = this.error.message;
      }
    } else {
      this.errorMessage = this.error;
    }
    this.findSupportEmail();
  }

  findSupportEmail() {
    const routerUrl = this.router.url;
    const serviceType = this.findserviceType(routerUrl);
    const userSupportEmail = this.userService.getServiceSupportContactInfo(serviceType);
    this.isUISupportEmail = userSupportEmail?.enable && !!userSupportEmail.email;
    if (this.isUISupportEmail) {
      this.supportEmail = userSupportEmail.email;
    }
    this.isUISupportPhone = userSupportEmail?.enable && !!userSupportEmail.phone;
    if (this.isUISupportPhone) {
      this.supportNumber = userSupportEmail.phone;
    }
  }

  findserviceType(routerUrl: string): ServiceType {
    const searchObj = this.searchService.search_objects;
    const searchValues = Object.values(searchObj);
    switch (true) {
      case routerUrl === searchValues[0].searchUrl:
        return searchValues.find((service) => service.chosen)?.type;
      case routerUrl.includes('results'):
        return searchValues.find((service) => service.resultUrl === routerUrl)?.type;
      case routerUrl === '/live-rail':
        return ServiceType.Rail;
      case routerUrl.includes('itinerary'):
        const basketId = routerUrl.split('/')[2];
        // this is showing the old ID or undefined if nothing was previously selected, so we need to grab from url for now
        // const basketId = this.basketService.basketChangeEmitter.value;
        this.bookableBasket.loadBasket(basketId);
        const currentBasket = this.bookableBasket.basket.value;
        return currentBasket.basketItems.length === 1
          ? currentBasket.basketItems[0].service.type
          : null;
      default:
        return null;
    }
  }
  acceptNewPrice() {
    const basketId = this.router.url.split('/')[2];
    const currentBasket = this.bookableBasket.basket.value;
    const errorItem = currentBasket.basketItems.find(
      (item) => item?.bookingDetail?.errors === this.errorMessage
    );
    if (errorItem?.id) {
      this.basketService.acceptNewPrice(basketId, errorItem as BasketItem);
      this.activeModal.close();
    }
  }
  addNewCard() {
    window.location.reload();
    this.activeModal.close();
  }
}

LightningModalTypes.ModalNetWorkErrorComponent.component = ModalNetworkErrorComponent;
@Component({
  templateUrl: './modal-search-error.component.html',
  standalone: false
})
export class ModalSearchErrorComponent {
  constructor(public activeModal: NgbActiveModal) {}

  public error = 'This Needs to be set';
}
LightningModalTypes.ModalSearchErrorComponent.component = ModalSearchErrorComponent;

@Component({
  templateUrl: './modal-search-timeout.component.html',
  standalone: false
})
export class ModalSearchTimeoutComponent {
  constructor(public activeModal: NgbActiveModal) {}
  public closeModal = null;
}
LightningModalTypes.ModalSearchTimeoutComponent.component = ModalSearchTimeoutComponent;

/*
   ===================== Confirm Logout ======================
*/

@Component({
  templateUrl: './modal-confirm.component.html',
  standalone: false
})
export class ModalConfirmComponent {
  private modal: NgbModalRef;
  constructor(
    public readonly activeModal: NgbActiveModal,
    public translator: TranslateService
  ) {}

  public btnOkText = this.translator.instant('Ok');
  public btnCancelText = this.translator.instant('No');
  public message = this.translator.instant(
    'Please note: Start again will reset all current results and baskets.'
  );
  public message_header = this.translator.instant('Confirmation needed');
}
LightningModalTypes.ModalConfirmComponent.component = ModalConfirmComponent;

@Component({
  templateUrl: './modal-traveller-error.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalTravellerErrorComponent {
  constructor(public activeModal: NgbActiveModal) {}

  public error = 'An Error Occured!';
}
LightningModalTypes.ModalTravellerErrorComponent.component = ModalTravellerErrorComponent;

@Component({
  templateUrl: './modal-confirm-card.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalConfirmCardComponent {
  constructor(public activeModal: NgbActiveModal) {}
}

LightningModalTypes.ModalConfirmCardComponent.component = ModalConfirmCardComponent;

@Component({
  templateUrl: './modal-recover-password.component.html',
  standalone: false
})
export class ModalRecoverPasswordComponent implements OnInit {
  expiredPassword = false;
  title = this.translator.instant('Recover Password');
  constructor(
    public activeModal: NgbActiveModal,
    public translator: TranslateService
  ) {}
  ngOnInit() {
    if (this.expiredPassword) {
      this.title = this.translator.instant('Expired Password');
    }
  }
}
LightningModalTypes.ModalRecoverPasswordComponent.component = ModalRecoverPasswordComponent;

@Component({
  templateUrl: './modal-expired-password.component.html',
  standalone: false
})
export class ModalExpiredPasswordComponent {
  constructor(public activeModal: NgbActiveModal) {}
}

LightningModalTypes.ModalExpiredPasswordComponent.component = ModalExpiredPasswordComponent;
@Component({
  templateUrl: './modal-card-error.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalCardErrorComponent {
  constructor(public activeModal: NgbActiveModal) {}
}
LightningModalTypes.ModalCardErrorComponent.component = ModalCardErrorComponent;

@Component({
  templateUrl: './modal-support-email.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalSupportEmailComponent {
  message: string;
  constructor(public activeModal: NgbActiveModal) {}
}
LightningModalTypes.ModalSupportEmailComponent.component = ModalSupportEmailComponent;

@Component({
  templateUrl: './modal-language-save.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalLanguageSaveComponent implements OnInit {
  Language: Language;
  emitter: EventEmitter<boolean>;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}

  save() {
    this.emitter.emit(true);
    this.activeModal.close(false);
  }

  onlySelect() {
    this.emitter.emit(false);
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(true);
  }
}
LightningModalTypes.ModalLanguageSaveComponent.component = ModalLanguageSaveComponent;
@Component({
  templateUrl: './modal-custom-error.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalCustomErrorComponent {
  errorTitle = '';
  errorMessage = '';

  constructor(public activeModal: NgbActiveModal) {}

  OK() {
    this.activeModal.close(true);
  }
}
LightningModalTypes.ModalCustomErrorComponent.component = ModalCustomErrorComponent;

@Component({
  templateUrl: './modal-screenreader-basket.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalScreenreaderBasketComponent {
  constructor(
    public activeModal: NgbActiveModal,
    public basketService: EnterpriseBasketService
  ) {}

  private manageFocusAfterDismissal(fallbackFocusElement?: HTMLElement, delay = 100): void {
    setTimeout(() => {
      const remainingModals = document.querySelectorAll('.modal.show');

      if (remainingModals.length > 0) {
        const topModal = remainingModals[remainingModals.length - 1];
        const focusableElements = topModal?.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
        ) as NodeListOf<HTMLElement>;

        focusableElements?.[0]?.focus();
      } else if (fallbackFocusElement && document.contains(fallbackFocusElement)) {
        fallbackFocusElement.focus();
      }
    }, delay);
  }

  continue() {
    this.activeModal.close(true);

    let fallbackElement: HTMLElement | undefined;
    if (window.location.hash.includes('flights')) {
      const focusable = document
        .getElementById('flight-container-2')
        ?.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
      fallbackElement = focusable?.[0] as HTMLElement;
    }

    this.manageFocusAfterDismissal(fallbackElement);
    this.basketService.closeMenu();
  }

  skipToBasket(event) {
    event.preventDefault();
    this.activeModal.close(true);

    const basketFocusable: NodeListOf<HTMLElement> =
      document
        .getElementById('basket')
        ?.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        ) || document.querySelectorAll('');

    let fallbackElement: HTMLElement | undefined;
    for (let i = 0; i < basketFocusable.length; i++) {
      const element = basketFocusable[i];
      if (window.getComputedStyle(element).display !== 'none' && element.tabIndex !== -1) {
        fallbackElement = element;
        break;
      }
    }

    this.manageFocusAfterDismissal(fallbackElement);
  }
}
LightningModalTypes.ModalScreenreaderBasketComponent.component = ModalScreenreaderBasketComponent;

@Component({
  templateUrl: './modal-hotel-check.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ModalHotelCheckComponent {
  constructor(public activeModal: NgbActiveModal) {}

  public nights: number = null;
  public location: string = null;
  public close = null;
  public modalContinue = null;

  accept() {
    this.activeModal.close(true);
    this.modalContinue();
  }

  reject() {
    this.activeModal.close(true);
    this.close();
  }
}

LightningModalTypes.ModalHotelCheckComponent.component = ModalHotelCheckComponent;

@Component({
  templateUrl: './modal-live-rail-legs.component.html',
  styleUrls: ['./../search/components/rail-live/rail-live-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ModalLiveRailLegsComponent {
  constructor(public activeModal: NgbActiveModal) {}
  public legs = null;

  public getTrainStatus(railItem: DepartureBoardService, stops = false): string {
    return stops
      ? moment(railItem.etd) > moment(railItem.std)
        ? 'Delayed'
        : 'On Time'
      : 'On Time';
  }
}

LightningModalTypes.ModalLiveRailLegsComponent.component = ModalLiveRailLegsComponent;

@Component({
  templateUrl: './modal-leave-itinerary.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ModalLeaveItineraryComponent {
  constructor(public activeModal: NgbActiveModal) {}

  displayItinerary = false;
}
LightningModalTypes.ModalLeaveItineraryComponent.component = ModalLeaveItineraryComponent;

@Component({
  templateUrl: './modal-lcc-markup.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalLccMarkup {
  public amount = 0;
  public cost = 0;
  constructor(public activeModal: NgbActiveModal) {}

  applyMarkup(): void {
    this.activeModal.close({ markup: { cost: this.cost, amount: this.amount } });
  }

  checkValue(value: string, type: 'amount' | 'cost') {
    if (!Number.isNaN(+value)) {
      type === 'amount' ? (this.amount = +value) : (this.cost = +value);
    }
  }
}
LightningModalTypes.ModalLccMarkup.component = ModalLccMarkup;
@Component({
  templateUrl: './modal-resend-approval-email.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ResendApprovalEmailComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {}
  data = false;
  ngOnInit() {
    console.log(this.data);
  }
}

LightningModalTypes.ResendApprovalEmailComponent.component = ResendApprovalEmailComponent;

@Component({
  selector: 'app-auto-logout',
  templateUrl: './auto-logout.component.html',
  standalone: false
})
export class AutoLoggingOutComponent implements OnInit, OnDestroy {
  public timeOutDuration = 60;
  public logout = LogoutEnum;

  constructor(
    private activeModal: NgbActiveModal,
    private logonService: LogonService
  ) {}
  private interval = null;

  ngOnInit(): void {
    this.interval = setInterval(() => this.checkInterval(), 1000);
  }

  checkInterval() {
    this.timeOutDuration -= 1;
    if (this.timeOutDuration <= 0) {
      clearInterval(this.interval);
      this.close(LogoutEnum.LOGOUT);
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  close(result: LogoutEnum) {
    if (result === LogoutEnum.LOGOUT) {
      this.logonService.logout();
    }
    this.activeModal.close(result);
  }
}

LightningModalTypes.AutoLoggingOutComponent.component = AutoLoggingOutComponent;

// @Component({
//   templateUrl: './modal-auto-logout.component.html'
// })
// export class AutoLogoutComponent {
//   constructor(public activeModal: NgbActiveModal) { }
// }

// LightningModalTypes.AutoLogoutComponent.component = AutoLogoutComponent;

@Component({
  templateUrl: './modal-wizzair-warning.component.html',
  standalone: false
})
export class ModalWizzairWarning {
  constructor(public activeModal: NgbActiveModal) {}
}

LightningModalTypes.ModalWizzairWarning.component = ModalWizzairWarning;

@Component({
  templateUrl: './modal-delete-saved-addresses.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalDeleteSavedAddresses extends WithSubscriptionComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {
    super();
  }

  public addresses = null;
  public removeAddress = null;
  public searchService = null;
  public addressList;
  ngOnInit() {
    this.subscribe(this.addresses, (event) => {
      this.addressList = event;
    });
  }
}
LightningModalTypes.ModalDeleteSavedAddresses.component = ModalDeleteSavedAddresses;

@Component({
  templateUrl: './modal-hotel-reviews.component.html',
  styleUrls: ['./modal.component.scss'],
  selector: 'app-hotel-reviews',
  standalone: false
})
export class ModalHotelReviewsComponent {
  constructor(
    public activeModal: NgbActiveModal,
    public iconLibrary: FaIconLibrary
  ) {
    this.iconLibrary.addIconPacks(far);
  }

  @Input() public hotelRatingsInfo = null;
}
LightningModalTypes.ModalHotelReviewsComponent.component = ModalHotelReviewsComponent;

@Component({
  templateUrl: './modal-car-details.component.html',
  styleUrls: ['./modal.component.scss'],
  selector: 'app-car-details-modal',
  standalone: false
})
export class ModalCarDetailsComponent implements OnInit {
  constructor(
    public activeModal: NgbActiveModal,
    public iconLibrary: FaIconLibrary
  ) {
    this.iconLibrary.addIconPacks(far);
  }

  @Input() public result = null;
  @Input() public carHireAvailabilityDetailsObject = null;
  @Input() public carTypeCodes = null;

  fareRules: CarHireDetailFareRule[] = [];

  ngOnInit() {
    if (this.carHireAvailabilityDetailsObject && this.result?.identifiers) {
      this.fareRules = this.getFareRules(
        this.carHireAvailabilityDetailsObject[
          `${this.result.identifiers.vendor}_${this.result.identifiers.vehType}`
        ]?.fareRules
      );
    }
  }

  getCo2Usage(result: CarHireVehicleAvailibility): string {
    try {
      return result.co2PerItem.toFixed(2);
    } catch (error) {}
    return '0.00';
  }

  getFareRules(fareRules: CarHireDetailFareRule[]) {
    const result = fareRules?.reduce((acc, item) => {
      switch (item.type) {
        case 'Vendor Message':
          const existing = acc.find((i) => i.type === 'Vendor Message');

          if (existing) {
            existing.messages.push(item.description);
          } else {
            acc.push({
              type: 'Vendor Message',
              messages: [item.description]
            });
          }
          break;

        case 'Mileage Allowance':
          if (item.allowance === 'UNL') {
            acc.push({
              type: item.type,
              description: 'UNLIMITED'
            });
          }
          break;

        default:
          acc.push(item);
          break;
      }
      return acc;
    }, []);

    return result;
  }

  getTypeForDisplayFromResult(result: CarHireVehicleAvailibility): string {
    const typeForDisplay = this.carTypeCodes.find(
      (carTypeCode) => carTypeCode[2] === result?.displayRecord?.vehicle?.type
    );
    if (typeForDisplay) {
      return typeForDisplay[1];
    }
  }
}
LightningModalTypes.ModalCarDetailsComponent.component = ModalCarDetailsComponent;

@Component({
  templateUrl: './modal-custom-warning.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalCustomWarningComponent {
  warningMessage: string = null;
  exclamationURL =
    'https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/exclamation-circle-solid.svg';
  constructor(public activeModal: NgbActiveModal) {}

  OK() {
    this.activeModal.close();
  }
}
LightningModalTypes.ModalCustomWarningComponent.component = ModalCustomWarningComponent;

@Component({
  templateUrl: './modal-rail-tickets.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalRailTickets {
  readonly eTicketIcon = 'https://images.sabscorp.com/images/sabs2/icons/eticket.jpg';
  tickets: OBTRailJourneyFare[] = null;
  sourceName = null;
  journey: OBTRailJourneyOption = null;
  selectedTicket: OBTRailJourneyFare = null;
  priceSoFar = 0;
  RailFareTypes: typeof RailFareTypes = RailFareTypes;
  RailDirection: typeof RailDirection = RailDirection;
  RailSearchJourneyType: typeof RailSearchJourneyType = RailSearchJourneyType;
  ServiceProvider: typeof ServiceProvider = ServiceProvider;
  searchType: RailSearchJourneyType = null;
  previouslySelectedTicket: {
    journey: any;
    fare: OBTRailJourneyFare;
  } = null;
  constructor(
    public activeModal: NgbActiveModal,
    private modalService: ModalOpenerService,
    private fareProcessingService: RailFareProcessingService
  ) {}

  isGroupFare(ticket: RailJourneyFare): boolean {
    if (ticket) {
      return this.fareProcessingService.isGroupFare(ticket);
    }
    return false;
  }

  calculateSplitSavings(ticket: OBTRailJourneyFare): number {
    if (!ticket.identifiers?.isSplit) {
      return 0;
    }

    const ticketPrice = Number(ticket.price);
    if (!ticketPrice || !this.tickets?.length) {
      return 0;
    }

    const cheapestNonSplitTicket = this.findCheapestNonSplitTicket(ticket);
    let splitType: 'advance' | 'flexible' | 'combined' | null = null;
    if (ticket.identifiers?.fares) {
      const fares = ticket.identifiers.fares;
      const hasAdvance = fares.some((fare) => fare?.name?.toLowerCase().includes('advance'));
      const hasFlexible = fares.some((fare) => {
        const nameLower = fare?.name?.toLowerCase() || '';
        return (
          nameLower.includes('off-peak') ||
          nameLower.includes('anytime') ||
          nameLower.includes('super off-peak')
        );
      });
      const hasPremiumOrStandard = fares.some((fare) => {
        const nameLower = fare?.name?.toLowerCase() || '';
        return nameLower.includes('standard') || nameLower.includes('premium');
      });

      if (hasAdvance && hasPremiumOrStandard) {
        splitType = 'combined';
      } else if (hasAdvance && hasFlexible) {
        splitType = 'combined';
      } else if (hasAdvance) {
        splitType = 'advance';
      } else if (hasFlexible) {
        splitType = 'flexible';
      }
    }

    let comparisonTicket: OBTRailJourneyFare | null = null;
    let cheapestPrice = Number.MAX_SAFE_INTEGER;

    for (const candidateTicket of this.tickets) {
      if (
        candidateTicket.identifiers?.isSplit ||
        candidateTicket.class !== ticket.class ||
        candidateTicket.singleOrReturn !== ticket.singleOrReturn
      ) {
        continue;
      }

      const candidatePrice = Number(candidateTicket.price);
      if (!candidatePrice) {
        continue;
      }

      let isMatch = false;
      const candidateTypeLower = candidateTicket.type?.toLowerCase() || '';

      if (splitType === 'advance') {
        isMatch = candidateTypeLower.includes('advance');
      } else if (splitType === 'flexible') {
        isMatch =
          candidateTypeLower.includes('off-peak') ||
          candidateTypeLower.includes('anytime') ||
          candidateTypeLower.includes('super off-peak');
      } else if (splitType === 'combined') {
        isMatch =
          candidateTypeLower.includes('advance') ||
          candidateTypeLower.includes('off-peak') ||
          candidateTypeLower.includes('anytime') ||
          candidateTypeLower.includes('super off-peak');
      } else {
        isMatch = true;
      }

      if (isMatch && candidatePrice < cheapestPrice) {
        comparisonTicket = candidateTicket;
        cheapestPrice = candidatePrice;
      }
    }

    // If no type-specific match found, fall back to cheapest non-split ticket
    if (!comparisonTicket) {
      comparisonTicket = cheapestNonSplitTicket;
      cheapestPrice = comparisonTicket ? Number(comparisonTicket.price) : Number.MAX_SAFE_INTEGER;
    }

    if (!comparisonTicket) {
      return 0;
    }

    const savings = cheapestPrice - ticketPrice;
    return savings > 0 ? savings : 0;
  }

  private findCheapestNonSplitTicket(ticket: OBTRailJourneyFare): OBTRailJourneyFare | null {
    const nonSplitTickets = this.tickets.filter(
      (candidateTicket) =>
        !candidateTicket.identifiers?.isSplit &&
        candidateTicket.class === ticket.class &&
        candidateTicket.singleOrReturn === ticket.singleOrReturn &&
        candidateTicket.selectable &&
        !candidateTicket.unavailable
    );

    if (!nonSplitTickets.length) {
      return null;
    }

    return nonSplitTickets.reduce((cheapest, current) => {
      if (!cheapest || Number(current.price) < Number(cheapest.price)) {
        return current;
      }
      return cheapest;
    });
  }

  private formatCurrency(amount: number, currency: string): string {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  }

  async openRailTicketDetailsDialog(ticket: OBTRailJourneyFare) {
    if (this.journey && ticket) {
      const terms = ticket.terms;
      const identifiers = ticket.identifiers;

      if (terms?.length > 1 && identifiers?.isSplit) {
        await this.modalService.open(
          LightningModalTypes.RailFareListComponent,
          { centered: true },
          {
            outboundFareTermsList: terms,
            outboundFares: identifiers.fares,
            splitType: identifiers.composition?.[0],
            origin: this.journey.from,
            destination: this.journey.to,
            serviceName: this.sourceName
          }
        );
      } else {
        await this.modalService.open(
          LightningModalTypes.RailFareTermsComponent,
          { centered: true },
          {
            ticketDetails: terms?.[0]?.terms
          }
        );
      }
    }
  }
}
LightningModalTypes.ModalRailTickets.component = ModalRailTickets;
@Component({
  templateUrl: './modal-no-credit-card-error.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalNoCreditCardErrorComponent {
  constructor(public activeModal: NgbActiveModal) {}

  public serviceType = '';
  public isSabre = false;

  OK() {
    this.activeModal.close(true);
  }
}
LightningModalTypes.ModalNoCreditCardErrorComponent.component = ModalNoCreditCardErrorComponent;

@Component({
  templateUrl: './modal-parking-details.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalParkingDetailsComponent {
  constructor(public activeModal: NgbActiveModal) {}

  public item: ParkingQuote = null;
}

LightningModalTypes.ModalParkingDetailsComponent.component = ModalParkingDetailsComponent;

@Component({
  templateUrl: './modal-lounge-details.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalLoungeDetailsComponent {
  constructor(public activeModal: NgbActiveModal) {}

  public item: LoungeQuote = null;
}

LightningModalTypes.ModalLoungeDetailsComponent.component = ModalLoungeDetailsComponent;

@Component({
  templateUrl: './modal-fasttrack-details.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalFasttrackDetailsComponent {
  constructor(public activeModal: NgbActiveModal) {}

  public item: FastTrackQuote = null;
}

LightningModalTypes.ModalFasttrackDetailsComponent.component = ModalFasttrackDetailsComponent;
